const LOAD_DETAIL_CATEGORY           = 'LOAD_DETAIL_CATEGORY'
const LOAD_DETAIL_CATEGORY_SUCCESS   = 'LOAD_DETAIL_CATEGORY_SUCCESS'
const LOAD_DETAIL_CATEGORY_FAILED    = 'LOAD_DETAIL_CATEGORY_FAILED'
const UNMOUNT_DETAIL_CATEGORY        = 'UNMOUNT_DETAIL_CATEGORY'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const categoryDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_CATEGORY:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_CATEGORY_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_CATEGORY_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_CATEGORY:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default categoryDetailReducer;